export const QueryStatus = ({
  isLoading,
  error,
  errorText,
}: {
  isLoading: boolean;
  error: unknown;
  errorText: string;
}) => (
  <>
    {isLoading && <p>Загрузка…</p>}
    {Boolean(error) && <div className="alert alert-danger">{errorText}</div>}
  </>
);
